
































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ia_agent } from "@/shared/classes/ia_agents_store";

@Component({
  components: {}
})
export default class http_agent_editor_dialog extends Vue {
  @Prop({ default: null }) public value!: ia_agent | null;

  public model: any = {
    id: "",
    name: "",
    description: "",
    category: "",
    icon: "🔗",
    tags: [],
    isPublic: false,
    comenzar: "",
    kind: "http",
    http: {
      url: "",
      method: "POST",
      headers: {},
      bodyTemplate: "",
      resultPath: "",
      timeoutMs: 15000,
      authType: "none",
      // Campos de auth (se rellenan si aplican)
      authUser: "",
      authPassword: "",
      authToken: ""
    }
  };

  public tagsProxy: string[] = [];

  // ----- Computadas -----
  get isEditMode(): boolean {
    return !!(this.value && this.value.id);
  }

  get isValid(): boolean {
    var hasHttp = this.model && this.model.http;
    var nameOk =
      this.model &&
      typeof this.model.name === "string" &&
      this.model.name.trim().length > 0;
    var urlOk =
      hasHttp &&
      typeof this.model.http.url === "string" &&
      this.model.http.url.trim().length > 0;
    return !!(nameOk && urlOk);
  }

  get headersStr(): string {
    try {
      var headers = (this.model && this.model.http && this.model.http.headers) ? this.model.http.headers : {};
      return JSON.stringify(headers, null, 2);
    } catch (e) {
      return "{}";
    }
  }
  set headersStr(v: string) {
    try {
      if (this.model && this.model.http) {
        this.model.http.headers = JSON.parse(v || "{}");
      }
    } catch (e) {
      // Ignorar errores de parseo; no rompemos la edición
    }
  }

  // ----- Ciclo de vida / Watchers -----
  mounted() {
    this.syncFromProp();
    console.log(this.model);
  }

  @Watch("value")
  on_value_changed() {
    this.syncFromProp();
  }

  @Watch("model.http.authType")
  on_auth_type_changed(newVal: string, oldVal: string) {
    // Limpiar credenciales que no apliquen al cambiar de tipo
    if (!this.model || !this.model.http) return;

    if (newVal === "none") {
      this.model.http.authUser = "";
      this.model.http.authPassword = "";
      this.model.http.authToken = "";
    } else if (newVal === "basic") {
      this.model.http.authToken = "";
    } else if (newVal === "bearer") {
      this.model.http.authUser = "";
      this.model.http.authPassword = "";
    }
  }

  private syncFromProp() {
    if (this.value && this.value.id) {
      // Clonado profundo para evitar mutación accidental del prop
      this.model = JSON.parse(JSON.stringify(this.value));
      if (!this.model.http) {
        this.model.http = {
          url: "",
          method: "POST",
          headers: {},
          bodyTemplate: "",
          resultPath: "",
          timeoutMs: 15000,
          authType: "none",
          authUser: "",
          authPassword: "",
          authToken: ""
        };
      } else {
        // asegurar claves faltantes
        if (typeof this.model.http.headers !== "object" || this.model.http.headers === null) {
          this.model.http.headers = {};
        }
        if (typeof this.model.http.method !== "string" || this.model.http.method.length === 0) {
          this.model.http.method = "POST";
        }
        if (typeof this.model.http.timeoutMs !== "number") {
          this.model.http.timeoutMs = 15000;
        }
        if (typeof this.model.http.authType !== "string" || this.model.http.authType.length === 0) {
          this.model.http.authType = "none";
        }
        if (typeof this.model.http.authUser !== "string") this.model.http.authUser = "";
        if (typeof this.model.http.authPassword !== "string") this.model.http.authPassword = "";
        if (typeof this.model.http.authToken !== "string") this.model.http.authToken = "";
      }
    } else {
      this.model = {
        id: "",
        name: "",
        description: "",
        category: "",
        icon: "🔗",
        tags: [],
        isPublic: false,
        comenzar: "",
        kind: "http",
        http: {
          url: "",
          method: "POST",
          headers: {},
          bodyTemplate: "",
          resultPath: "",
          timeoutMs: 15000,
          authType: "none",
          authUser: "",
          authPassword: "",
          authToken: ""
        }
      };
    }

    this.tagsProxy = this.model && this.model.tags ? this.model.tags.slice(0) : [];
  }

  // ----- Acciones -----
  public save() {
    // Normalizar tags y emitir
    this.model.tags = (this.tagsProxy || []).map(function(t: string) { return t ? t.trim() : t; }).filter(function(t: string) { return !!t; });
    this.$emit("save", this.model);
  }
}
